import { render, staticRenderFns } from "./BoostInfoContent.vue?vue&type=template&id=23fbd9d4&scoped=true"
import script from "./BoostInfoContent.vue?vue&type=script&lang=js"
export * from "./BoostInfoContent.vue?vue&type=script&lang=js"
import style0 from "./BoostInfoContent.vue?vue&type=style&index=0&id=23fbd9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fbd9d4",
  null
  
)

export default component.exports